import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { ControllerBase } from 'src/app-client/_appCommon/base/ControllerBase';
import { GlobalConstants, PaymentType, PaymentTypeArray } from 'src/app/_appCommon/base/AppInterfaceAndBaseClasses';
import { Product, ProductType, Service, ShoppingCartItem } from 'src/app-client/_appCommon/base/AppInterfaceAndBaseClasses';
import { ShoppingCartDataService } from 'src/app-client/_dataservices/ShoppingCartDataService';
import { ShowInSection } from '../../../app/_appCommon/base/AppInterfaceAndBaseClasses';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.css']
})
export class CheckoutComponent extends ControllerBase
{
  @ViewChild('confirmDeleteProductForCase') protected confirmDeleteProductForCase: any;

  public currentCart: ShoppingCartItem[];
  public defaultImage = GlobalConstants.altProductImagePath;
  public itemIndexSelected: number = null;
  public paymentTypeArray:any
  public paymentTypeSelected: PaymentType = null;

  constructor(
    private router: Router,
    private shoppingCartDataService: ShoppingCartDataService
  )
  {
    super();
    this.shoppingCartDataService.setPercentageForMSIUsage(0);
  }

  ngOnInit(): void
  {
    this.paymentTypeArray = PaymentTypeArray.filter(e=> (e.showIn == ShowInSection.Both || e.showIn == ShowInSection.Ecommerce) );

    this.shoppingCartDataService.getItems()
      .subscribe(cart =>
      {
        this.currentCart = cart;
      });
  }

  public getItemImage(images: any, item: Product): string
  {
    if (this.shoppingCartDataService.isProduct(item))
    {
      return images.length > 0 ? images[0].url : this.defaultImage;
    }
    else
    {
      return images.url ?? this.defaultImage;
    }
  }

  public onRemoveItem(itemIndex: number): void
  {
    if(this.getCaseId)
    {
      this.confirmDeleteProductForCase.show = true;
      this.itemIndexSelected = itemIndex;
      return;
    }

    this.setInfoAlert(this.shoppingCartDataService.onDeleteItem(itemIndex));
  }

  public onRemoveCaseIdAndProductFromShoppingCart(): void
  {
    this.setInfoAlert(this.shoppingCartDataService.onDeleteItem(this.itemIndexSelected));

    this.confirmDeleteProductForCase.show = false;
  }

  public onUpdateQuantityItem(itemIndex: number, quantity: number): void
  {
    this.shoppingCartDataService.onUpdateQuantityItem(itemIndex, quantity);
  }

  public get getSubtotal(): number
  {
    return this.shoppingCartDataService.getSubtotal();
  }

  public get getTax(): number
  {
    return this.shoppingCartDataService.getTax();
  }

  public get getTotal(): number
  {
    return this.shoppingCartDataService.getTotal();
  }

  public get getCaseId(): number
  {
    return this.shoppingCartDataService.caseId;
  }

  public get getCasePatientName(): string
  {
    return this.shoppingCartDataService.casePatientName;
  }

  public isDisabledItemQuantityChange(item: Product | Service): boolean
  {
    return this.getCaseId && this.isProduct(item);
  }

  public onProcessPaymentType(): void
  {
    if(!this.paymentTypeSelected)
    {
      this.setInfoAlert("Selecciona un método de pago");
      return;
    }

    if(this.currentCart.length == 0)
    {
      this.setInfoAlert("Agrega un producto al carrito antes de continuar");
      return;
    }

    if(this.currentCartHasService() && !this.shoppingCartDataService.caseId)
    {
      this.setWarningAlert("El carrito tiene servicios adicionales pero no pueden ser asignados a un caso.");
      return;
    }

    switch(this.paymentTypeSelected)
    {
      case PaymentType.OpenPay:
        this.router.navigate(['ecommerce/openpay']);
        break;
      case PaymentType.PayNet:
        this.router.navigate(['ecommerce/paynet']);
        break;
      case PaymentType.SPEI:
        this.router.navigate(['ecommerce/spei']);
        break;
      case PaymentType.PayLink:
        this.router.navigate(['ecommerce/paylink']);
        break;
      case PaymentType.CardPay:
        this.router.navigate(['ecommerce/cardpay']);
        break;

      default:
        this.setInfoAlert("Selecciona un metodo de pago");
        break;
    }
  }

  public onGoStore(): void
  {
    this.router.navigate(['ecommerce/tienda']);
  }

  public isProduct(item: Product | Service): boolean
  {
    return this.shoppingCartDataService.isProduct(item);
  }

  public isAccesoryProductType(item: any): boolean
  {
    return item?.productType == ProductType.Accessory;
  }

  public currentCartHasService(): boolean
  {
    return this.currentCart.some(x => !this.isProduct(x.item));
  }

  isSetupProduct(product: any ):boolean {
    if(product.hasOwnProperty('productType')){
      return product.productType == ProductType.Setup;
    }
    return false;
  }

  public getTotalByItem(itemCart:any): number
  {
    return this.shoppingCartDataService.getTotalByItem(itemCart);
  }

  public getTaxByItem(itemCart:any): number
  {
    return this.shoppingCartDataService.getTaxByItem(itemCart);
  }

  public getSubtotalByItem(itemCart:any): number
  {
    return this.shoppingCartDataService.getSubtotalByItem(itemCart);
  }
}
